"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
require("@xyflow/react/dist/style.css");
var react_1 = require("@xyflow/react");
var challenge_1 = require("../../../../reducers/slices/challenge/challenge");
var constants_1 = require("./components/constants");
var react_redux_1 = require("react-redux");
var react_2 = require("@heroui/react");
var challenge_node_menu_1 = require("./components/challenge_node_menu");
var utils_1 = require("@doshexchnage/utils");
var react_3 = require("@iconify/react");
var label_1 = require("../../../../controls/label");
var main_1 = require("../../../../reducers/slices/main");
var challengeEditorContext_1 = require("../../../../contexts/challengeEditorContext");
var getNodeConfig = function (nodeType, nodeName, category) {
    return constants_1.NodeConfigurations[category].find(function (node) { return node.type === nodeType && node.data.name === nodeName; });
};
function ChallengeEditor(_a) {
    var _this = this;
    var className = _a.className;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.challengeState; }), selectedChallenge = _b.selectedChallenge, nodes = _b.nodes, edges = _b.edges, nodeModal = _b.nodeModal;
    var isReadOnly = (0, challengeEditorContext_1.useChallengeReadOnly)();
    var _onNodesChange = function (nodeChanges) { return dispatch((0, challenge_1.onNodesChange)(nodeChanges)); };
    var _onEdgesChange = function (edgeChanges) { return dispatch((0, challenge_1.onEdgesChange)(edgeChanges)); };
    var _onConnect = function (connection) {
        if (isReadOnly)
            return;
        dispatch((0, challenge_1.onConnect)(connection));
    };
    var _onBeforeDelete = function (mhm) { return __awaiter(_this, void 0, void 0, function () {
        var nodes;
        return __generator(this, function (_a) {
            if (isReadOnly)
                return [2 /*return*/, false];
            nodes = mhm.nodes;
            if (!selectedChallenge._id || !nodes.some(function (node) { return node.data.node_type === "objective"; })) {
                return [2 /*return*/, true];
            }
            dispatch((0, main_1.setContentModal)({
                title: "Confirm deletion of objective trees",
                content: ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4 justify-center", children: [(0, jsx_runtime_1.jsx)(label_1.Label, { label: "Deleting this objective tree could result in multiple side effects, like your users losing access to this objective and it's rewards.", textColor: "text-inputText", center: true }), (0, jsx_runtime_1.jsx)(label_1.Label, { label: "Are you sure you wish to continue?", textColor: "text-inputText", center: true }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-row pt-4 gap-4 justify-center", children: [(0, jsx_runtime_1.jsx)(react_2.Button, { size: "md", variant: "secondary", onPress: function () { return dispatch((0, main_1.setContentModal)(null)); }, children: "Cancel" }), (0, jsx_runtime_1.jsx)(react_2.Button, { size: "md", variant: "primary", onPress: function () {
                                        dispatch((0, challenge_1.onNodesDelete)(nodes));
                                        dispatch((0, main_1.setContentModal)(null));
                                    }, children: "Remove" })] })] })),
            }));
            return [2 /*return*/, false];
        });
    }); };
    var addNode = function (_a) {
        var nodeType = _a.nodeType, nodeName = _a.nodeName, category = _a.category;
        var id = "".concat(nodeType, "-").concat(utils_1.Generate.randomAlphanumeric(8));
        var nodeConfig = getNodeConfig(nodeType, nodeName, category);
        dispatch((0, challenge_1.setNodes)(__spreadArray(__spreadArray([], nodes, true), [
            {
                id: id,
                type: nodeType,
                position: { x: 0, y: 0 },
                data: nodeConfig.data,
                selected: true,
            },
        ], false)));
        if (nodeModal.nodeId) {
            dispatch((0, challenge_1.setEdges)(__spreadArray(__spreadArray([], edges, true), [{ id: id, source: nodeModal.nodeId, target: id }], false)));
        }
        dispatch((0, challenge_1.setIsEdited)(true));
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.ReactFlow, { nodes: nodes, edges: edges, onNodesChange: _onNodesChange, onEdgesChange: _onEdgesChange, onConnect: _onConnect, onBeforeDelete: _onBeforeDelete, nodeTypes: constants_1.nodeTypes, fitView: true, fitViewOptions: {
            maxZoom: 1,
        }, className: "grow ".concat(className, " shadow-inner"), nodesDraggable: false, panOnDrag: [2, 1], zoomOnScroll: false, zoomOnPinch: true, zoomOnDoubleClick: false, panOnScroll: true, panOnScrollSpeed: 0.5, nodesConnectable: false, children: [(0, jsx_runtime_1.jsx)(react_1.Background, { bgColor: "var(--surface-secondary)", color: "color-mix(in oklch, var(--muted) 45%, transparent)", gap: 20, size: 1.5 }), (0, jsx_runtime_1.jsx)(react_1.Panel, { position: "top-left", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center gap-4", children: [(0, jsx_runtime_1.jsx)(label_1.Label, { label: "Objectives", textColor: "text-primary", size: "large", bold: true }), !isReadOnly ? ((0, jsx_runtime_1.jsxs)(react_2.Button, { size: "sm", variant: (nodes === null || nodes === void 0 ? void 0 : nodes.length) ? "secondary" : "primary", onPress: function () { return dispatch((0, challenge_1.setNodeModal)({ isOpen: true, nodeTypes: ["objective"] })); }, children: [(0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "mdi:add" }), "Add Objective"] })) : null] }) }), nodeModal.isOpen && !isReadOnly && ((0, jsx_runtime_1.jsx)(challenge_node_menu_1.ChallengeNodeMenu, { onNodeSelect: function (props) {
                    addNode(props);
                    dispatch((0, challenge_1.setNodeModal)(__assign(__assign({}, nodeModal), { isOpen: false })));
                } }))] }));
}
exports.default = ChallengeEditor;
